/*------------------------------------*\
    measurements
\*------------------------------------*/
module.exports = function(){




    var initMagnificPopup = function(){

        $('.js-newmeaspopup-trigger').magnificPopup({
            mainClass: 'mfp-zoom-in  mfp-measpopup',
            type: 'inline',
            removalDelay: 500,
            preloader: false,
        });

    };

    initMagnificPopup();







    if ( $('.js-new-measurement-form').length ) {
        var newMeasurementParsley = $('.js-new-measurement-form').parsley();
    }

    $('.js-new-measurement-form').on('submit', function(event) {
        event.preventDefault();

        var form = $(this);

        if ( $(this).parsley().isValid() ) {

            var name = $(this).find('input[name="Name"]').val();


            var requestData = {
                CustomerId: globalOmsCustomerId,
                Name: name,
                BodyTypeShoulderId: 1,
                BodyTypePostureId: 2,
                BodyTypeChestId: 3
            };


            $.ajax({
                url: EPH_API_URL + '/customerMeasurementProfiles',
                type: 'POST',
                dataType: 'json',
                data: requestData,

                complete: function(jqXHR, textStatus){

                    callback(jqXHR, textStatus);

                },

                success: function(data, textStatus, jqXHR){

                    form.find('.js-form-callback')
                        .html('New Measurement Profile created successfully.<br />Reloading page...')
                        .addClass('is-visible')
                        .removeClass('is-error')
                        .addClass('is-success');

                    location.reload();

                },

                error: function(jqXHR, textStatus, errorThrown){

                    form.find('.js-form-callback')
                        .text(jqXHR.responseJSON.msg)
                        .addClass('is-visible')
                        .removeClass('is-success')
                        .addClass('is-error');

                },

            });



        }


    });






}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/measurements_new_measurement.js